import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './redux/configureStore';
import * as serviceWorker from './serviceWorker';
import locales from '../locales/index';
import App from './App';
import './main.css';
import './fontStyle.css';

locales.setActiveLanguage('fa-ir');
global.locales = locales.localize;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
serviceWorker.register();
